var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "inward"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', {
    attrs: {
      "title": _vm.$t('ticketsupport.createTicket')
    }
  }, [_c('br'), _vm._v(" "), (_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('ticketsupport.helpTopic')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.helpTopic),
      expression: "helpTopic"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('helpTopic')
    },
    attrs: {
      "name": "helpTopic"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.helpTopic = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ticketsupport.helpTopic')))]), _vm._v(" "), _vm._l((_vm.helpTopicData), function(obj) {
    return _c('option', {
      domProps: {
        "value": obj.topicid
      }
    }, [_vm._v(_vm._s(obj.topicname))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('helpTopic')),
      expression: "errors.has('helpTopic')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('ticketsupport.helptopicError')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('receivedEmail.Subject')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('subject')
    },
    attrs: {
      "name": "subject",
      "type": "text",
      "id": "ticketSubject",
      "placeholder": _vm.$t('ticketsupport.ticketSubhectPlaceHolder')
    },
    model: {
      value: (_vm.ticketSubject),
      callback: function($$v) {
        _vm.ticketSubject = $$v
      },
      expression: "ticketSubject"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subject')),
      expression: "errors.has('subject')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('ticketsupport.subjectError')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('errorLogReport.description')) + "  ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.templateDescription),
      expression: "templateDescription"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('description')
    },
    attrs: {
      "id": "templateDescription",
      "name": "description",
      "type": "text",
      "placeholder": _vm.$t('errorLogReport.description')
    },
    domProps: {
      "value": (_vm.templateDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description')),
      expression: "errors.has('description')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productDescPlaceHolder')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file",
      "name": "csv"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inwardfooter form-actions"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.isLoading,
      "type": "button"
    },
    on: {
      "click": _vm.createTicket
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(_vm._s(_vm.$t('ticketsupport.createTicket')))]), _vm._v(" \n          "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeTicket
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.back')))])])])], 1)])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9e67e7f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e67e7f8","hasScoped":true}!./src/views/components/addticket/addticket.component.html
// module id = 1872
// module chunks = 0